import { Box, Button, Modal, Typography } from "@mui/material";
import { fontSize } from "../theme/fontSize";
import CustomButton from "../button/button";
import { apiErrorMessage } from "../../helper/apiError";
import { ThemeColor } from "../theme/color";
import { updateSupportTicketStatus } from "../../Redux/service/SupportService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { sm: "50%", xs: "50%", md: "50%", lg: "50%" },
    height: "20vh",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "2px solid grey",
    boxShadow: 24,
    p: 4,
    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '10px' },
    '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '10px' },
    '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
};

export const SettleSupport = ({ open, handleClose, id, dispatch }) => {

    const handleSettle = async () => {
        try {
            const resp = await updateSupportTicketStatus(true, id);
            if (resp.status == 200) {
                dispatch(showSnackbar(resp.data.message, "success"))
            }
            handleClose()
        } catch (err) {
            dispatch(showSnackbar(apiErrorMessage(err), "error"))
        }
    }

    return <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >

        <Box sx={style}>
            <Typography sx={{ fontSize: fontSize.h1.small }} align="center">Are You sure to settle this ticket</Typography>
            <Box justifyContent={"center"} alignSelf={"center"} display={"flex"} flex={1}>
                <div style={{ margin: 10 }}>
                    <CustomButton onClick={handleClose} backgroundColor={ThemeColor.RED} color={ThemeColor.WHITE}>Cancel</CustomButton>
                </div>
                <div style={{ margin: 10 }}>

                    <CustomButton
                        backgroundColor={ThemeColor.PURPLE}
                        color={ThemeColor.WHITE}
                        onClick={handleSettle}
                    >Yes Settel</CustomButton>
                </div>
            </Box>
        </Box>
    </Modal>

}